"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EngagementToolEnum;
(function (EngagementToolEnum) {
    EngagementToolEnum["OVERALL"] = "overall";
    EngagementToolEnum["QUERIES"] = "queries";
    EngagementToolEnum["CATEGORIES"] = "categories";
    EngagementToolEnum["KEYWORDS"] = "keywords";
    EngagementToolEnum["ORIGINS"] = "origins";
    EngagementToolEnum["NOW"] = "now";
    EngagementToolEnum["EQUALIZE"] = "equalize";
    EngagementToolEnum["SYNONYMS"] = "synonyms";
    EngagementToolEnum["BLACKLIST"] = "blacklist";
    EngagementToolEnum["PROMOTIONS"] = "promotions";
    EngagementToolEnum["REDIRECTIONS"] = "redirections";
    EngagementToolEnum["SEARCH_CONFIGURATIONS"] = "search_configurations";
    EngagementToolEnum["RELATED_TAGS"] = "related_tags";
    EngagementToolEnum["NEXT_QUERIES"] = "next_queries";
    EngagementToolEnum["INDEX"] = "index";
    EngagementToolEnum["EXPLAIN"] = "explain";
    EngagementToolEnum["AUDIT"] = "audit";
    EngagementToolEnum["NAVIGATION_CONFIGURATIONS"] = "navigation_configurations";
    EngagementToolEnum["PRIVACY"] = "privacy";
    EngagementToolEnum["YEARLY_SUMMARY"] = "yearly_summary";
})(EngagementToolEnum = exports.EngagementToolEnum || (exports.EngagementToolEnum = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW5nYWdlbWVudC10b29sLmVudW0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvZW51bXMvZW5nYWdlbWVudC9lbmdhZ2VtZW50LXRvb2wuZW51bS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLElBQVksa0JBcUJYO0FBckJELFdBQVksa0JBQWtCO0lBQzVCLHlDQUFtQixDQUFBO0lBQ25CLHlDQUFtQixDQUFBO0lBQ25CLCtDQUF5QixDQUFBO0lBQ3pCLDJDQUFxQixDQUFBO0lBQ3JCLHlDQUFtQixDQUFBO0lBQ25CLGlDQUFXLENBQUE7SUFDWCwyQ0FBcUIsQ0FBQTtJQUNyQiwyQ0FBcUIsQ0FBQTtJQUNyQiw2Q0FBdUIsQ0FBQTtJQUN2QiwrQ0FBeUIsQ0FBQTtJQUN6QixtREFBNkIsQ0FBQTtJQUM3QixxRUFBK0MsQ0FBQTtJQUMvQyxtREFBNkIsQ0FBQTtJQUM3QixtREFBNkIsQ0FBQTtJQUM3QixxQ0FBZSxDQUFBO0lBQ2YseUNBQW1CLENBQUE7SUFDbkIscUNBQWUsQ0FBQTtJQUNmLDZFQUF1RCxDQUFBO0lBQ3ZELHlDQUFtQixDQUFBO0lBQ25CLHVEQUFpQyxDQUFBO0FBQ25DLENBQUMsRUFyQlcsa0JBQWtCLEdBQWxCLDBCQUFrQixLQUFsQiwwQkFBa0IsUUFxQjdCIn0=